/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */

import {
  useFetchCorporateGroups,
  useFetchCorporatePlans,
} from '../../../utils/queries/corporate';
// import AddCorporateGroupModal from '../AddCorporateGroupModal';
import { Table, Tag, Typography } from 'antd';
import { find, get, map } from 'lodash-es';
import { EditOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';

const { Title } = Typography;

export default function GroupsList({ corporateId }) {
  const [isAddCorporateGroupOpen, setAddCorporateGroupOpen] = useState(false);
  const [editCorporateGroupObject, setEditCorporateGroupObject] =
    useState(null);
  const { data: groups, isLoading, refetch } = useFetchCorporateGroups();
  const { data: plans = [] } = useFetchCorporatePlans();

  const onClickEditIcon = (group) => {
    setEditCorporateGroupObject(group);
    setAddCorporateGroupOpen(true);
  };

  const getPlanNameById = (planId) => {
    const plan = plans?.data?.find((p) => p.ID === planId);
    return plan?.NAME || '';
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'NAME',
      render: (name, group) => <>{group?.NAME}</>,
      key: 'NAME',
    },
    {
      title: 'Plan',
      dataIndex: 'JP_CORPORATE_PLAN',
      render: (name, group) => <>{getPlanNameById(group?.JP_CORPORATE_PLAN)}</>,
      key: 'JP_CORPORATE_PLAN',
    },
    // {
    //   title: 'No. of Chargers',
    //   dataIndex: 'CHARGERS_COUNT',
    //   render: (name, group) => <>15</>,
    //   key: 'CHARGERS_COUNT',
    // },
    {
      title: 'Location',
      dataIndex: 'LOCATION',
      render: (name, group) => <>{group?.LOCATION}</>,
      key: 'LOCATION',
    },
    {
      title: 'Status',
      dataIndex: 'IS_ACTIVE',
      render: (name, group) => (
        <Tag color={get(group, 'IS_ACTIVE') ? 'green' : 'orange'}>
          {get(group, 'IS_ACTIVE') ? 'Active' : 'Inactive'}
        </Tag>
      ),
      key: 'IS_ACTIVE',
    },
    // {
    //   title: 'Actions',
    //   dataIndex: '',
    //   render: (name, group) => (
    //     <>
    //       <EditOutlined
    //         onClick={() => {
    //           onClickEditIcon(group);
    //         }}
    //         style={{ cursor: 'pointer' }}
    //       />
    //     </>
    //   ),
    //   key: '',
    // },
  ];

  const closeAddCorporateGroup = () => {
    setAddCorporateGroupOpen(false);
  };

  const getTitle = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <Title level={4} style={{ paddingBottom: 2 }}>
        Groups{' '}
        {/* <PlusCircleOutlined
          style={{ color: '#2675b8', cursor: 'pointer' }}
          onClick={() => {
            setAddCorporateGroupOpen(true);
          }}
        /> */}
      </Title>
    </div>
  );

  return (
    <>
      <Table
        style={{ marginTop: 20 }}
        rowKey="key"
        columns={columns}
        dataSource={groups?.data?.length > 0 ? groups?.data : []}
        pagination={false}
        title={() => getTitle()}
      />
      {/* <AddCorporateGroupModal
        corporateId={corporateId}
        editCorporateGroupObject={editCorporateGroupObject}
        isModalVisible={isAddCorporateGroupOpen}
        closeAddCorporateGroup={closeAddCorporateGroup}
        triggerRefreshList={refetch}
      /> */}
    </>
  );
}
